import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import PasswordForm from '../../../components/password-form/PasswordForm'
import { Card, CardBody } from 'shards-react'
import CustomizedCardHeader from '../../../components/customized-card-header/CustomizedCardHeader'
import { FormAuthContainer } from './style'
import useForm from '../../../hooks/useForm'
import AuthService from '../../../services/auth-service/AuthService'
import ErrorHandler from '../../../utils/ErrorHandler'
import { GenericAlert } from '../../../components/alert/GenericAlert'
import CardHeaderUtils from '../../../utils/CardHeaderUtils'
import Loading from '../../../components/loading/Loading'

const UserChangePassword = ({ props }) => {
    const initialState = {
        isFecthing: false,
        newPassword: '',
        newPasswordConfirmation: '',
        currentPassword: '',
        score: 0,
        success: false,
        hasError: false,
    }

    const initialAlertValues = {
        isAlertVisible: false,
        alertMessage: '',
        alertTheme: '',
    }

    const { values, setValue, setAllValues } = useForm(initialState)
    const [alertValues, setAlertValues] = useState(initialAlertValues)
    const [menuList, setMenuList] = useState([])
    const informations = { isFecthing: values.isFecthing }
    const [name, setName] = useState('')

    useEffect(() => {
        async function getMenuList() {
            const menuItems = CardHeaderUtils.getSettingsMenuList('UserChangePassword')
            setMenuList(menuItems)
        }

        async function getName() {
            if (props && props.location && props.location.state && props.location.state.name) {
                setName(props.location.state.name)
            } else {
                const decodedToken = await AuthService.getDecodedToken()
                setName(decodedToken.name)
            }
        }

        getName()
        getMenuList()
    }, [])

    const infoCurrentPasswordInput = {
        type: 'password',
        label: 'Senha atual',
        name: 'currentPassword',
        value: values.currentPassword,
        // valid: values.currentPassword && values.newPassword === values.newPasswordConfirmation ? true : false,
    }
    const infoNewPasswordInput = {
        type: 'password',
        label: 'Nova Senha',
        name: 'newPassword',
        value: values.newPassword,
        valid: values.newPassword && values.newPassword === values.newPasswordConfirmation ? true : false,
    }
    const infoConfirmPasswordInput = {
        type: 'password',
        label: 'Confirmar Nova Senha',
        name: 'newPasswordConfirmation',
        value: values.newPasswordConfirmation,
        valid: values.newPasswordConfirmation && values.newPasswordConfirmation === values.newPassword ? true : false,
    }
    const configButton = {
        theme: 'primary',
        label: 'Redefinir senha',
    }
    const changeScore = score => {
        const valuesDeepClone = JSON.parse(JSON.stringify(values))
        valuesDeepClone.score = score
        setAllValues(valuesDeepClone)
    }

    const closeAlert = () => {
        setAlertValues({ ...alertValues, ...initialAlertValues })
    }

    const redefinePassword = event => {
        event.preventDefault()
        setAllValues({ ...values, ...{ hasError: false, isFetching: true, showBackLink: false } })
        const { currentPassword, newPassword, newPasswordConfirmation, score } = values

        if (score <= 1) {
            const _alertValues = {
                // eslint-disable-next-line quotes
                alertMessage: "Ops! Senhas com os status 'muito fraca' ou 'fraca' não são permitidas.",
                alertTheme: 'danger',
                isAlertVisible: true,
            }
            setAlertValues({ ...alertValues, ..._alertValues })
            setAllValues({
                ...values,
                ...{
                    hasError: true,
                    success: false,
                    isFetching: false,
                },
            })
            return
        }
        if (newPasswordConfirmation !== newPassword) {
            const _alertValues = {
                alertMessage:
                    'O campo Confirmar Nova Senha deve ser preenchido, de forma identica ao campo Nova Senha.',
                alertTheme: 'danger',
                isAlertVisible: true,
            }
            setAlertValues({ ...alertValues, ..._alertValues })
            setAllValues({
                ...values,
                ...{
                    hasError: true,
                    success: false,
                    isFetching: false,
                },
            })
            return
        }

        AuthService.changePassword(newPassword, currentPassword)
            .then(() => {
                const _alertValues = {
                    alertMessage: 'Alteramos a sua senha.',
                    alertTheme: 'success',
                    isAlertVisible: true,
                }
                setAlertValues({ ...alertValues, ..._alertValues })
                setAllValues({
                    ...values,
                    ...{ success: true, hasError: false, isFetching: false, showBackLink: true },
                })
            })
            .catch(e => {
                const _alertValues = {
                    alertMessage: 'Não foi possível alterar a senha.',
                    alertTheme: 'danger',
                    isAlertVisible: true,
                }
                setAlertValues({ ...alertValues, ..._alertValues })
                setAllValues({
                    ...values,
                    ...{
                        success: false,
                        hasError: true,
                        isFetching: false,
                        showBackLink: true,
                    },
                })
                ErrorHandler.handleError(e)
            })
    }
    const actions = {
        formSubmit: redefinePassword,
        onchange: setValue,
        onChangeScore: changeScore,
    }

    return (
        <React.Fragment>
            {values.isFetching ? (
                <Loading />
            ) : (
                <Card small className="mb-4">
                    <CustomizedCardHeader
                        className={'border-bottom'}
                        initialName={`Trocar senha: ${name}`}
                        menuList={menuList}
                    />
                    <CardBody>
                        <GenericAlert
                            className="mb-3 cypreGenericAlert"
                            dismissible={closeAlert}
                            open={alertValues.isAlertVisible}
                            theme={alertValues.alertTheme}
                        >
                            {alertValues.alertMessage}
                        </GenericAlert>
                        <FormAuthContainer>
                            <PasswordForm
                                informations={informations}
                                actions={actions}
                                configFirstInput={infoNewPasswordInput}
                                configSecondtInput={infoConfirmPasswordInput}
                                configExtraInput={infoCurrentPasswordInput}
                                configButton={configButton}
                            />
                        </FormAuthContainer>
                    </CardBody>
                </Card>
            )}
        </React.Fragment>
    )
}

UserChangePassword.propTypes = {
    props: PropTypes.object,
    location: PropTypes.object,
}

export default UserChangePassword
